/**
 * Returns purpose paragraphs not already consumed by the project-detail hero.
 *
 * The first purpose paragraph is the stable project summary shown in the hero.
 * Additional paragraphs remain available as supporting project-purpose detail.
 */
export function projectPurposeDetails(purpose: readonly string[]): string[] {
  return purpose.slice(1);
}
